
export const formFields = {
  marginValue: {
    key: 'marginValue',
    type: 'number',
    label: 'Margin Value',
    placeholder: 'Enter Margin Value...',
    required: true,
    requiredMessage: 'This field is required.',
    min: 0,
    // minLengthMessage: 'Minimum 1 charactors allowed.',
    max: 99999,
    upto3Digit: true,
    // maxLengthMessage: 'maximum 10 characters allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Margin Value </div>',
    // pattern: /^\d{1,10}$|(?=^.{1,10}$)^(0|[1-9]\d*)(\.\d+)?$/,
    patternMessage: 'Please enter valid Value',
    spaceNotAllowed: true,
},

};

export const confirmationMessage = {
  action: {
    confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
    type: 'Confirmation'
  }
}

export const successfullyMessage = {
  action: {
    confirmationMessage: 'Successfully Saved Margin Details',
    type: 'Success',
  }
}



export const Goal = [
  { key: '1', value: 'CPM' },
  { key: '2', value: 'Clicks' },
  { key: '3', value: 'CPC' },
  { key: '4', value: 'CTR' },
  { key: '5', value: 'VCR' },
  { key: '6', value: 'CPA / CPL' },
  { key: '7', value: 'VTR' },
]
export const roStaus = [
  { key: '1', value: 'Active' },
  { key: '0', value: 'Inactive' },
]


// export const Goal = [
//   { key: '1', value: 'CPM' },
//   { key: '2', value: 'Clicks' },
//   { key: '3', value: 'CPC' },
//   { key: '4', value: 'CTR' },
//   { key: '5', value: 'VCR' },
//   { key: '6', value: 'CPA / CPL' },
//   { key: '7', value: 'VTR' },
// ]
// export const roStaus = [
//   { key: '1', value: 'Active' },
//   { key: '0', value: 'Inactive' },
// ]


export const ModelSelect = [
  { value: 'CPC', label: 'CPC', name:'model' },
  { value: 'CPM', label: 'CPM', name:'model' },
  // { value: 'vanilla', label: 'Vanilla' },
];
export const ModelTypeSelect = [
  { value: '%value', label: '%Value', name:'Type' },
  { value: 'fixedValue', label: 'Fixed Value' , name:'Type' },
  // { value: 'vanilla', label: 'Vanilla' },
];
export const AdTypeSelectData = [
  { value: 'Display', label: 'Display' ,name:'adType' },
  { value: 'Video', label: 'Video' ,name:'adType' },
  { value: 'Search', label: 'Search',name:'adType' },
  { value: 'Social', label: 'Social',name:'adType' },
];
export const PlatformSelect = [
  { value: 'ION', label: 'ION',name:'platform' },
  { value: 'DV 360', label: 'DV 360',name:'platform' },
  { value: 'Google Adwords', label: 'Google Adwords',name:'platform' },
  { value: 'Facebook', label: 'Facebook',name:'platform' },
];
